import _pt from 'prop-types';
import 'react';
import i18n from 'i18next';
import "../i18n.js";
import { jsx, Global } from '@emotion/core';
import { Modal, ModalHeader, ModalBody, ModalFooter, ButtonToolbar, Button } from '@appfolio/react-gears';

var EsignatureConsentModal = function EsignatureConsentModal(_ref) {
  var isOpen = _ref.isOpen,
      submitButtonDisabled = _ref.submitButtonDisabled,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;
  return jsx(Modal, {
    isOpen: isOpen,
    toggle: onClose,
    backdrop: true,
    zIndex: "10050",
    size: "lg",
    className: "js-esignature-consent-modal"
  }, jsx(Global, {
    styles: {
      '.modal': {
        zIndex: 10050
      }
    }
  }), jsx(ModalHeader, {
    toggle: onClose
  }, i18n.t('signables.headings.finalize_document')), jsx(ModalBody, {
    className: "pb-2"
  }, i18n.t('signables.messages.affirmative_consent')), jsx(ModalFooter, null, jsx(ButtonToolbar, null, jsx(Button, {
    disabled: submitButtonDisabled,
    color: "primary",
    onClick: onSubmit,
    className: "js-submit-button"
  }, i18n.t('signables.actions.sign_and_accept')))));
};

EsignatureConsentModal.displayName = "EsignatureConsentModal";
EsignatureConsentModal.propTypes = {
  isOpen: _pt.bool.isRequired,
  submitButtonDisabled: _pt.bool.isRequired,
  onClose: _pt.func.isRequired,
  onSubmit: _pt.func.isRequired,
  children: _pt.node
};
export default EsignatureConsentModal;